import React, { useState } from "react";
import { FaCalculator } from "react-icons/fa";

const rupees = (value) =>
	Number.isFinite(value)
		? `Rs. ${Math.round(value).toLocaleString("en-IN")}`
		: "—";

// Compact loan calculator: three inputs, results update as you type.
const EMICalculator = () => {
	const [amount, setAmount] = useState(100000);
	const [rate, setRate] = useState(8.03);
	const [months, setMonths] = useState(36);

	const principal = Number(amount);
	const term = Number(months);
	const monthlyRate = Number(rate) / 1200;

	let emi = NaN;
	if (principal > 0 && term > 0 && Number(rate) >= 0) {
		emi =
			monthlyRate === 0
				? principal / term
				: (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -term));
	}
	const total = emi * term;
	const interest = total - principal;

	return (
		<section className='sec'>
			<div className='container'>
				<div className='emi'>
					<div className='emi-head'>
						<FaCalculator /> Loan EMI Calculator
					</div>
					<div className='emi-body'>
						<div className='emi-inputs'>
							<label>
								Loan amount (Rs.)
								<input
									type='number'
									min='0'
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
								/>
							</label>
							<label>
								Interest rate (% per year)
								<input
									type='number'
									min='0'
									step='0.01'
									value={rate}
									onChange={(e) => setRate(e.target.value)}
								/>
							</label>
							<label>
								Term (months)
								<input
									type='number'
									min='1'
									value={months}
									onChange={(e) => setMonths(e.target.value)}
								/>
							</label>
						</div>
						<div className='emi-results'>
							<div className='emi-main'>
								<span>Monthly payment</span>
								<strong>{rupees(emi)}</strong>
							</div>
							<div>
								<span>Total interest</span>
								<strong>{rupees(interest)}</strong>
							</div>
							<div>
								<span>Total payment</span>
								<strong>{rupees(total)}</strong>
							</div>
						</div>
						<p className='emi-note'>
							This is an estimate. Ask the office for the rate that applies to
							your loan.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default EMICalculator;
